import React, { useState } from 'react';

const initialTasks = [
    { id: 1, title: 'Fuite sur toiture', status: 'Ouvert' },
    { id: 2, title: 'Vérification des fondations', status: 'En cours' },
    { id: 3, title: 'Pose de l’isolant thermique', status: 'Cloturé' },
    { id: 4, title: 'Déclaration dégât des eaux', status: 'Ouvert' },
    { id: 5, title: 'Réparation fissure façade', status: 'En cours' }
];

const statuses = ['Ouvert', 'En cours', 'Cloturé'];

const TrelloBoard = () => {
    const [tasks, setTasks] = useState(initialTasks);

    const handleDrop = (taskId, newStatus) => {
        setTasks(prevTasks =>
            prevTasks.map(task =>
                task.id === taskId ? { ...task, status: newStatus } : task
            )
        );
    };

    const onDragStart = (e, taskId) => {
        e.dataTransfer.setData('taskId', taskId);
    };

    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDrop = (e, status) => {
        const taskId = parseInt(e.dataTransfer.getData('taskId'), 10);
        handleDrop(taskId, status);
    };

    return (
        <div class="p-6">
            <h1 className="mb-6 font-bold text-2xl">Suivi des Déclarations</h1>
            <div className="flex gap-6">
                {statuses.map(status => (
                    <div
                        key={status}
                        onDragOver={onDragOver}
                        onDrop={(e) => onDrop(e, status)}
                        className="bg-gray-800 shadow-md p-4 rounded-lg w-1/3"
                    >
                        <h2 className="mb-4 font-bold text-white text-xl">{status}</h2>
                        <div className="space-y-4">
                            {tasks.filter(task => task.status === status).map(task => (
                                <div
                                    key={task.id}
                                    draggable
                                    onDragStart={(e) => onDragStart(e, task.id)}
                                    className="bg-orange-600 shadow p-3 rounded text-white cursor-move"
                                >
                                    {task.title}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TrelloBoard;
